import { Order, OrderPosition, User } from '@types';

export interface CreditInvoice {
  id: number;
  creditId: number;
  invoiceNumber: number;
  total: number;
  totalIva: number;
  isIva: boolean;
  isIvaMinus: boolean;
  company: string;
  state: string;
  status: CreditInvoiceStatusType;
  file: CreditInvoiceFile;
  comment: string;
  createdAt: string;
  commentedAt: string;
  invoices?: CreditInvoice[];
  positions: OrderPosition[];
  positionsCost: number;
  isPending: boolean;
  isApproved: boolean;
  isDenied: boolean;
  extension: string | null;
  userId: number | null;
  managerId: number | null;
  managerName: string | null;
  retailerId: number | null;
  retailerName: string | null;
  adminId: number | null;
  adminName: number | null;
  zipState: string | null;
  isXml: boolean;
  xmlCompany: string | null;
  xmlCert: string | null;
  xmlDate: string | null;
  xmlProducts: string[];
  xmlSubtotal: number;
  xmlTotal: number;
  xmlZipCode: string | null;
  xmlEmisorName: string | null;
  xmlUuid: string | null;
  discountAmount: number | null;
  isrPercent: number | null;
  iepsPercent: number | null;
  isrAmount: number | null;
  iepsAmount: number | null;
  finalAmount: number;
  order?: Order;
  financeAnalysisStatus: boolean | null;
  cxAnalysisStatus: boolean | null;
  invoiceAccredited: string | null;
  history: CreditInvoiceHistory[];
  user: User;
}

export enum CreditInvoiceStatusType {
  PENDING = 'pending',
  APPROVED = 'approved',
  DENIED = 'denied',
}

export interface CreditInvoiceFile {
  id: number;
  adminUrl: string;
  isPdf: boolean;
  isImage: boolean;
  isXml: boolean;
  url?: string;
  originalName?: string;
  createdAt: string;
  updatedAt?: string;
}

export interface CreditInvoiceHistory {
  id: number;
  title: string;
  entity: CreditInvoiceHistoryEntityType;
  statusBefore: string | null;
  statusAfter: string | null;
  createdAt: string;
  adminId: number | null;
  adminName: string | null;
}

export enum CreditInvoiceHistoryEntityType {
  FINANCE = 'FINANCE',
  CX = 'CX',
}
